import { TableContext } from 'labguard-cdk'
import GroupListView from './GroupListView'

export default TableContext.withProvider()(GroupListView)
